import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { Router } from '@/constants/Router';

const rootContainer = document.getElementById('root');
const root = createRoot(rootContainer!);

root.render(
  <StrictMode>
    <RouterProvider router={Router} />
  </StrictMode>,
);
